import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import Debounce from 'lodash/debounce'
import CustomSlider from '../blocs/custom_slider.vue'

export default {
	data() {
		return {}
	},
	props: ['params'],
	methods: {
		switch_dechets_qty() {
			this.$store.dispatch('switchFilterDechetsQty');
		},
		switch_dechet_qty() {
			this.$store.dispatch('switchFilterDechetQty');
		},
		formatData(value) {
			if (this.is_float) {
				return value / 100;
			} else {
				return value;
			}
		},
	},
	computed:{
		getDechetsMinQty: {
			// accesseur
			get: function() {
				let val = [];
				let dechets_qty = this.$store.state.filters.dechets_qty_default
				let min_max = this.$store.state.filters.dechets_qty_min_max

				if (dechets_qty == false) {
					val = [this.getDechetsQtyMin, this.getDechetsQtyMax]
				} else {
					val = dechets_qty
				}

				if (min_max != false) {
					if (val[0] < this.getDechetsQtyMin) val[0] = this.getDechetsQtyMin
					if (val[1] > this.getDechetsQtyMax) val[1] = this.getDechetsQtyMax
				}
				return val[0]
			},
			// mutateur
			set: function(value) {
				let dechets_qty = _.cloneDeep(this.$store.state.filters.dechets_qty_default)
				dechets_qty[0] = _.cloneDeep(value)

				if (dechets_qty[1] < dechets_qty[0]) dechets_qty[0] = dechets_qty[1]
		        if (this.getDechetsQtyMin > dechets_qty[0]) {
		          dechets_qty[0] = this.getDechetsQtyMin
		        }

				this.$store.dispatch('setDechetsQty', dechets_qty)
			}
		},
		getDechetsMaxQty: {
			// accesseur
			get: function() {
				let val = [];
				let dechets_qty = this.$store.state.filters.dechets_qty_default
				let min_max = this.$store.state.filters.dechets_qty_min_max

				if (dechets_qty == false) {
					val = [this.getDechetsQtyMin, this.getDechetsQtyMax]
				} else {
					val = dechets_qty
				}

				if (min_max != false) {
					if (val[0] < this.getDechetsQtyMin) val[0] = this.getDechetsQtyMin
					if (val[1] > this.getDechetsQtyMax) val[1] = this.getDechetsQtyMax
				}
				return val[1]
			},
			// mutateur
			set: function(value) {
				let dechets_qty = _.cloneDeep(this.$store.state.filters.dechets_qty_default)
				dechets_qty[1] = _.cloneDeep(value)
				
				if (dechets_qty[1] < dechets_qty[0]) dechets_qty[1] = dechets_qty[0]
		        if (this.getDechetsQtyMax < dechets_qty[1]) {
		          dechets_qty[1] = this.getDechetsQtyMax
		        }

				this.$store.dispatch('setDechetsQty', dechets_qty)
			}
		},
		getDechetsQty: {
			// accesseur
			get: function() {
				let val = [];
				let dechets_qty = this.$store.state.filters.dechets_qty_default
				let min_max = this.$store.state.filters.dechets_qty_min_max

				if (dechets_qty == false) {
					val = [this.getDechetsQtyMin, this.getDechetsQtyMax]
				} else {
					val = dechets_qty
				}

				if (min_max != false) {
					if (val[0] < this.getDechetsQtyMin) val[0] = this.getDechetsQtyMin
					if (val[1] > this.getDechetsQtyMax) val[1] = this.getDechetsQtyMax
				}
				return val
			},
			// mutateur
			set: Debounce(function(value) {
				let v = _.cloneDeep(value)
				this.$store.dispatch('setDechetsQty', v)
			}, 500)
		},
		getDechetsQtyMarks() {
			return [this.getDechetsQtyMin, this.getDechetsQtyMax]
		},
		getDechetsQtyMin() {
			return Math.floor(this.$store.state.filters.dechets_qty_min_max[0]);
		},
		getDechetsQtyMax() {
			return Math.ceil(this.$store.state.filters.dechets_qty_min_max[1]);
		},
		getDefaultDechetsQtyMin() {
			let dechets_qty = this.$store.state.filters.dechets_qty_default
			return this.$store.state.filters.dechets_qty_active ? dechets_qty[0] : this.$store.state.filters.dechets_qty_min_max[0];
		},
		getDefaultDechetsQtyMax() {
			let dechets_qty = this.$store.state.filters.dechets_qty_default
			return this.$store.state.filters.dechets_qty_active ? dechets_qty[1] : this.$store.state.filters.dechets_qty_min_max[1];
		},


		//AS--> Filtre par quantité de chaque déchet
		getDechetMinQty: {
			// accesseur
			get: function() {
				let val = [];
				let dechet_qty = this.$store.state.filters.dechet_qty_default
				let min_max = this.$store.state.filters.dechet_qty_min_max

				if (dechet_qty == false) {
					val = [this.getDechetQtyMin, this.getDechetQtyMax]
				} else {
					val = dechet_qty
				}

				if (min_max != false) {
					if (val[0] < this.getDechetQtyMin) val[0] = this.getDechetQtyMin
					if (val[1] > this.getDechetQtyMax) val[1] = this.getDechetQtyMax
				}
				return val[0]
			},
			// mutateur
			set: function(value) {
				let dechet_qty = _.cloneDeep(this.$store.state.filters.dechet_qty_default)
				dechet_qty[0] = _.cloneDeep(value)

				if (dechet_qty[1] < dechet_qty[0]) dechet_qty[0] = dechet_qty[1]
		        if (this.getDechetQtyMin > dechet_qty[0]) {
		          dechet_qty[0] = this.getDechetQtyMin
		        }

				this.$store.dispatch('setDechetQty', dechet_qty)
			}
		},
		getDechetMaxQty: {
			// accesseur
			get: function() {
				let val = [];
				let dechet_qty = this.$store.state.filters.dechet_qty_default
				let min_max = this.$store.state.filters.dechet_qty_min_max

				if (dechet_qty == false) {
					val = [this.getDechetQtyMin, this.getDechetQtyMax]
				} else {
					val = dechet_qty
				}

				if (min_max != false) {
					if (val[0] < this.getDechetQtyMin) val[0] = this.getDechetQtyMin
					if (val[1] > this.getDechetQtyMax) val[1] = this.getDechetQtyMax
				}
				return val[1]
			},
			// mutateur
			set: function(value) {
				let dechet_qty = _.cloneDeep(this.$store.state.filters.dechet_qty_default)
				dechet_qty[1] = _.cloneDeep(value)
				
				if (dechet_qty[1] < dechet_qty[0]) dechet_qty[1] = dechet_qty[0]
		        if (this.getDechetQtyMax < dechet_qty[1]) {
		          dechet_qty[1] = this.getDechetQtyMax
		        }

				this.$store.dispatch('setDechetQty', dechet_qty)
			}
		},
		getDechetQty: {
			// accesseur
			get: function() {
				let val = [];
				let dechet_qty_defaut = this.$store.state.filters.dechet_qty_default
				let min_max_choisis_internaute = this.$store.state.filters.dechet_qty_min_max

				if (dechet_qty_defaut == false) {
					val = [this.getDechetQtyMin, this.getDechetQtyMax]
				} else {
					val = dechet_qty_defaut
				}

				if (min_max_choisis_internaute != false) {
					if (val[0] < this.getDechetQtyMin) val[0] = this.getDechetQtyMin
					if (val[1] > this.getDechetQtyMax) val[1] = this.getDechetQtyMax
				}
				return val
			},
			// mutateur
			set: Debounce(function(value) {
				let v = _.cloneDeep(value)
				this.$store.dispatch('setDechetQty', v)
			}, 500)
		},
		getDechetQtyMarks() {
			return [this.getDechetQtyMin, this.getDechetQtyMax]
		},
		getDechetQtyMin() {
			return Math.floor(this.$store.state.filters.dechet_qty_min_max[0]);
		},
		getDechetQtyMax() {
			return Math.ceil(this.$store.state.filters.dechet_qty_min_max[1]);
		},
		getDefaultDechetQtyMin() {
			let dechet_qty = this.$store.state.filters.dechet_qty_default
			let qty = this.$store.state.filters.dechet_qty_active ? dechet_qty[0] : this.$store.state.filters.dechet_qty_min_max[0];
			if(undefined === qty || Number.isNaN(qty)) qty = 0;
			return qty;
		},
		getDefaultDechetQtyMax() {
			let dechet_qty = this.$store.state.filters.dechet_qty_default
			let qty = this.$store.state.filters.dechet_qty_active ? dechet_qty[1] : this.$store.state.filters.dechet_qty_min_max[1];
			if(undefined === qty || Number.isNaN(qty)) qty = 0;
			return qty;
		}

	},
	watch: {},
	components: {
		VueSlider,
		CustomSlider
	}
}